import { useEffect, useRef } from 'react';

// Ouverture ciblée d'un élément (depuis une notification push ou le Fil du jour).
// Un écran consomme la demande via `useOuvrirElement(kind, handler)` ; à défaut, la carte
// portant `data-ouvrir="kind:id"` est mise en surbrillance et affichée à l'écran.
// La demande reste lisible 20 s pour les écrans montés après coup (chargement paresseux, onglets).
const KEY = 'ouvrir_element';
const EVENT = 'ouvrir-element';
const TTL = 20000;

export const demanderOuverture = (detail) => {
  if (!detail?.kind) return;
  const d = { ...detail, stamp: Date.now() };
  try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch { /* quota */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: d }));
  surlignerElement(d.kind, d.id);
};

const lirePending = () => {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (p && Date.now() - (p.stamp || 0) < TTL) return p;
    if (p) sessionStorage.removeItem(KEY);
  } catch { /* ignore */ }
  return null;
};

export const useOuvrirElement = (kinds, handler) => {
  const ref = useRef(handler); ref.current = handler;
  const done = useRef(0);
  const list = Array.isArray(kinds) ? kinds.join('|') : kinds;
  useEffect(() => {
    const ok = (d) => d && list.split('|').includes(d.kind) && d.stamp !== done.current;
    const run = (d) => { done.current = d.stamp; ref.current(d); };
    const p = lirePending();
    if (ok(p)) run(p);
    const on = (e) => { if (ok(e.detail)) run(e.detail); };
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, [list]);
};

export const surlignerElement = (kind, id, essais = 25) => {
  if (!kind || !id) return;
  const el = document.querySelector(`[data-ouvrir="${kind}:${id}"]`);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('elem-surligne');
    setTimeout(() => el.classList.remove('elem-surligne'), 4500);
    return;
  }
  if (essais > 0) setTimeout(() => surlignerElement(kind, id, essais - 1), 300);
};
